import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpeaker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSpeaker"><Path d="M12 11.5C10.4812 11.5 9.25 12.7312 9.25 14.25C9.25 15.7688 10.4812 17 12 17C13.5188 17 14.75 15.7688 14.75 14.25C14.75 12.7312 13.5188 11.5 12 11.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V22H20V2ZM7.75 14.25C7.75 11.9028 9.65279 10 12 10C14.3472 10 16.25 11.9028 16.25 14.25C16.25 16.5972 14.3472 18.5 12 18.5C9.65279 18.5 7.75 16.5972 7.75 14.25ZM9 6V7.5H15V6H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpeaker;
